var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableAmount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.5 299h-7c-1.38.002-2.498 1.118-2.5 2.495v2.994c.002 1.378 1.12 2.494 2.5 2.495h7c1.38-.001 2.498-1.117 2.5-2.495v-2.994c-.002-1.377-1.12-2.493-2.5-2.495zm-7.5 6.487c-.276 0-.5-.223-.5-.499 0-.275.224-.499.5-.499s.5.224.5.5c0 .275-.224.498-.5.498zm0-3.992c-.276 0-.5-.223-.5-.499s.224-.499.5-.499.5.223.5.5c0 .275-.224.498-.5.498zm4 3.493c-1.105 0-2-.893-2-1.996 0-1.102.895-1.996 2-1.996s2 .894 2 1.996c0 1.103-.895 1.996-2 1.996zm4 .5c-.276 0-.5-.224-.5-.5 0-.275.224-.499.5-.499s.5.224.5.5c0 .275-.224.498-.5.498zm0-3.993c-.276 0-.5-.223-.5-.499s.224-.499.5-.499.5.223.5.5c0 .275-.224.498-.5.498zm-3 1.497c0 .551-.448.998-1 .998s-1-.447-1-.998c0-.551.448-.998 1-.998s1 .447 1 .998z",
    transform: "translate(-70 -299)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableAmount);
export default __webpack_public_path__ + "static/media/tableAmount.af59d2e9.svg";
export { ForwardRef as ReactComponent };